import { combineReducers } from 'redux';

import Admin from './Admin';
import CompanySettings from './CompanySettings';
import Reporting from './Reporting';
import PManagement from './PManagement';
import MTDB from './MTDB';
import Strategy from './Strategy';

export default combineReducers({
  Admin,
  CompanySettings,
  Reporting,
  PManagement,
  MTDB,
  Strategy,
});
